export default "__VITE_ASSET__COyPQjts__"